// extracted by mini-css-extract-plugin
export default {"editBar":"roleDashboard_editBar__clDOH","editHint":"roleDashboard_editHint__FAytu","editActions":"roleDashboard_editActions__8awmW"};